const { request, errorHandler } = require("../../utils")
const { default: api } = require("../../api")
const qs = require("querystring")

const isDev = (d) => d.email === 'dev@hubton.com' && d.password === 'secret'

const loginService = {
  async getTokenFromAPI(requestBody){
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }

    return new Promise(function(resolve, reject){
      if(isDev(requestBody)){
        // Fake Integration
        resolve({token: 'dev'})
      } else {
        // Real API Integration
        request({
          method: 'post',
          url: api.login,
          config,
          data: qs.stringify(requestBody),
        }).then((res) => {
          resolve(res)
        }).catch((err) => {
          const message = errorHandler(err)
          reject(message)
        })
      }
    })
  }
}

export default loginService
